import { useAuthState } from "react-firebase-hooks/auth";
import firebase from "firebase/app";

export const Dashboard = () => {
  const [user] = useAuthState(firebase.auth());
  return <>{`Hello, ${user?.email}`}</>;
};
